import {
  container,
//cardTitle,
//whiteColor,
//grayColor,
  ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

let mobileOpen = (window.innerWidth < 960) ? true : false; //console.log("mobileOpen="+mobileOpen);
let logo_width  = mobileOpen ? "80px" : "100px";
let logo_height = mobileOpen ? "80px" : "100px";

const BillsPaymentSetupStyle = theme => ({
  container: {
    ...container,
    backgroundColor: "#FFFFFF",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
    //transform:"translateZ(0) !important"//menis
    //transform: "translate3d(0,0,0)"
  },
  labelHeader: {
    marginTop        : 10,
    marginBottom     : 0,
    fontSize         : "1.7rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#FFDD00",
    textAlign        : "center",
  },
  BillsPaymentSetup_viewStepsInfo_lbl_lbl1: {
    marginTop        : 30,
    marginBottom     : 10,
    fontSize         : "1.2rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  BillsPaymentSetup_viewStepsInfo_lbl_lbl2: {
    marginTop        : 0,
    marginBottom     : 10,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#35B6B4",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  logo: {
    margin: "1rem 0",
    "& img": {
    //width   : "75%",
      width   : logo_width,//"100px",
      height  : logo_height,//"100px",
      display : "block",
      margin  : "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    },
  },
  companyIcon: {
    margin: "0rem 0",
    "& img": {
    //width   : "75%",
      width   : logo_width,//"100px",
      height  : logo_height,//"100px",
      display : "block",
      margin  : "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  Card_List_Icon_mobile: {
    margin: "0rem 0",
    "& img": {
      width:  "45px",
      height: "45px",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  Card_List_Icon_desktop: {
    margin: "0rem 0",
    "& img": {
      width:  "65px",
      height: "65px",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  checkBox_Icon_mobile: {
    margin: "0rem 0",
    "& img": {
      width:  "18px",
      height: "18px",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  checkBox_Icon_desktop: {
    margin: "0rem 0",
    "& img": {
      width:  "25px",
      height: "25px",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  listItembutton:{
    display: 'inline-block',
    padding:0,
    minHeight: 0,
    minWidth: 0,
    marginTop        : 2,
    marginBottom     : 2,
    textTransform    : 'none',
    color            : "#35B6B4",
  },
  listItem_date: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "100",
    color            : "#8D9A9E",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  listItem_TM: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "100",
    color            : "#8D9A9E",
    textAlign        : "right",
    "vertical-align" : "middle",
  },
  listItem_cardType: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  listItem_newCard: {
  //marginTop        : 2,
  //marginBottom     : 2,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "100",
    color            : "#3C3C43",
    opacity          : 0.6,
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  listItem_newCard_checked: {
  //marginTop        : 2,
  //marginBottom     : 2,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#251A75",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  listItem_other: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#8A8A8E",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  listItem_amount: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#303030",
    textAlign        : "right",
    "vertical-align" : "middle",
  },
  listItem_currency: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "0.9rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "normal",
    color            : "#303030",
    textAlign        : "right",
    "vertical-align" : "middle",
  },

  label1: {
    fontSize     : "1rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "300",
    color        : "#303030",
    textAlign    : "left",
    "vertical-align":"middle",
  },
  label2: {
    fontSize     : "1.0rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "300",
    color        : "#251A75",
    textAlign    : "left",
    "vertical-align":"middle",
  },
  BillsPaymentSetupStyle_lbl_status: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.2rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  BillsPaymentSetupStyle_lbl_date: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "0.9rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  textField1: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" }
  },
  textField2: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" }
  },
  textField3: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" }
  },
  textField4: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" }
  },

  textField10: { marginTop:10, marginBottom:10, input:{ color : "303030" } ,"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {display: "none"}, },
  textField11: { marginTop:10, marginBottom:10, input:{ color : "303030" } ,"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {display: "none"}, },
  textField12: { marginTop:10, marginBottom:10, input:{ color : "303030" } ,"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {display: "none"}, },
  textField13: { marginTop:10, marginBottom:10, input:{ color : "303030" } ,"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {display: "none"}, },
  textField14: { marginTop:10, marginBottom:10, input:{ color : "303030" } ,"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {display: "none"}, },
  textField15: { marginTop:10, marginBottom:10, input:{ color : "303030" } ,"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {display: "none"}, },
  textField16: { marginTop:10, marginBottom:10, input:{ color : "303030" } ,"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {display: "none"}, },
  textField17: { marginTop:10, marginBottom:10, input:{ color : "303030" } ,"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {display: "none"}, },
  textField18: { marginTop:10, marginBottom:10, input:{ color : "303030" } ,"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {display: "none"}, },
  textField19: { marginTop:10, marginBottom:10, input:{ color : "303030" } ,"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {display: "none"}, },

  D2BInfoText_lbl1: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  D2BInfoText_lbl2: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  D2BInfoText_lbl3: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  //--------
  //DropDown
  //--------
  picker1_textFieldLabel1: {
    marginTop        : 10,
    marginBottom     : 10,
  },
  picker1b_textFieldLabel1: {
    marginTop        : 10,
    marginBottom     : 10,
  },
  picker1c_textFieldLabel1: {
    marginTop        : 10,
    marginBottom     : 10,
  },
  picker2_textFieldLabel1: {
    marginTop        : 10,
    marginBottom     : 10,
  },

  picker10_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker11_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker12_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker13_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker14_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker15_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker16_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker17_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker18_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker19_textFieldLabel1: { marginTop:10, marginBottom:10 },

  GridItemLocal_d:{
  //paddingLeft  : "0px !important",
    paddingRight : "0px !important",
    paddingTop   : "0px !important",
    paddingBottom: "0px !important",
    marginLeft   : "0px !important",
    marginRight  : "0px !important",
    marginTop    : "0px !important",
    marginBottom : "0px !important",
  },
  GridItemLocal_m:{
    paddingLeft  : "4px !important",
    paddingRight : "4px !important",
    paddingTop   : "0px !important",
    paddingBottom: "0px !important",
    marginLeft   : "0px !important",
    marginRight  : "0px !important",
    marginTop    : "0px !important",
    marginBottom : "0px !important",
  },
  GridItemLocal_y:{
    paddingLeft  : "0px !important",
  //paddingRight : "0px !important",
    paddingTop   : "0px !important",
    paddingBottom: "0px !important",
    marginLeft   : "0px !important",
    marginRight  : "0px !important",
    marginTop    : "0px !important",
    marginBottom : "0px !important",
  },
  //-------
  //Buttons
  //-------
  yellowButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 50,
    marginBottom     : 20,
    color            : "#303030",
    backgroundColor  : "#FFDD00",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
    "&:focus"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
  },
  backButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 0,
    marginBottom     : 20,
    color            : "#0000ff",
    backgroundColor  : "rgba(255, 255, 255, 1.0)",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
    "&:focus"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
  },
  popupOkButton: {
    textTransform   : "none",
    backgroundColor : "#FFDD00",
    'border-radius' : "10px"
  },
  //----------
  //PleaseWait
  //----------
  pleaseWait: {
    marginTop        : 50,
  //marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
  //---------------
  //PleaseWaitPopup
  //---------------
  pleaseWaitPopup: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    overflow         : "hidden",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },

  HeaderMenuImage: {
    margin: "0rem 0",
    "& img": {
    //width   : "75%",
      width   : "40px",
      height  : "40px",
      display : "block",
      margin  : "auto"
    },
    "& span": {
      width   : "100px",
      height  : "1px",
      borderBottom: "3px solid " + ts_main[3],
      display : "block",
      margin  : "1rem auto"
    }
  },
});

export default BillsPaymentSetupStyle;
